<template>
  <b-row class="sidebar-block b" cols="1">
    <span class="d-none"> {{reload}} </span> 
    <b-col class="d-table border-before" v-if="leftMenuContent.Summary && leftMenuContent.Summary.content.length">
      <a @click="open('summary-1')" href="#" class="d-table-cell align-middle">Summary ▾</a>
    </b-col>
    <b-collapse v-if="leftMenuContent.hasOwnProperty('Summary') && leftMenuContent.Summary.content.length" id="summary-1" class="mt-2">
      <b-col 
        v-for="(content, index1) in leftMenuContent.Summary.content"
        class="d-table"
        :key="'a'+leftMenuContent.Summary.id[index1]"
      >
        <a @click="hello(0, leftMenuContent.Summary.id[index1])" href="#" class="d-table-cell align-middle">{{content[1]}}</a>
      </b-col>
    </b-collapse>
    <b-col class="d-table border-before" v-if="leftMenuContent.Abstract && leftMenuContent.Abstract.content.length">
      <a @click="open('abstract-1')" href="#" class="d-table-cell align-middle">Abstract ▾</a>
    </b-col>
    <b-collapse v-if="leftMenuContent.hasOwnProperty('Abstract') && leftMenuContent.Abstract.content.length" id="abstract-1" class="mt-2">
      <b-col 
        v-for="(content, index1) in leftMenuContent.Abstract.content"
        class="d-table"
        :key="'a'+leftMenuContent.Abstract.id[index1]"
      >
        <a @click="hello(1, leftMenuContent.Abstract.id[index1])" href="#" class="d-table-cell align-middle">{{content[1]}}</a>
      </b-col>
    </b-collapse>
    <b-col v-if="leftMenuContent.hasOwnProperty('Fulltext') && leftMenuContent.Fulltext.content.length" class="d-table border-before">
      <a @click="open('fulltext-1')" href="#" class="d-table-cell align-middle">Full text ▾</a>
    </b-col>
    <b-collapse v-if="leftMenuContent.hasOwnProperty('Fulltext') && leftMenuContent.Fulltext.content.length" id="fulltext-1" class="mt-2">
      <b-col 
        v-for="(content, index1) in leftMenuContent.Fulltext.content"
        class="d-table"
        :key="'b'+leftMenuContent.Fulltext.id[index1]"
      >
        <a @click="hello(2, leftMenuContent.Fulltext.id[index1])" href="#" class="d-table-cell align-middle">{{content[1]}}</a>
      </b-col>
    </b-collapse>
    <b-col v-if="leftMenuContent.hasOwnProperty('Appendix') && leftMenuContent.Appendix.content.length" class="d-table border-before">
      <a @click="open('appendix-1')" href="#" class="d-table-cell align-middle">Appendix ▾</a>
    </b-col>
    <b-collapse v-if="leftMenuContent.hasOwnProperty('Appendix') && leftMenuContent.Appendix.content.length" id="appendix-1" class="mt-2">
      <b-col 
        v-for="(content, index1) in leftMenuContent.Appendix.content"
        class="d-table"
        :key="'c'+leftMenuContent.Appendix.id[index1]"
      >
        <a @click="hello(3, leftMenuContent.Appendix.id[index1])" href="#" class="d-table-cell align-middle">{{content[1]}}</a>
      </b-col>
    </b-collapse>
  </b-row>
</template>

<script>
export default {
  name: 'RightSidebar',
  props: {
    leftMenuContent: Object,
    language: Object,
    selectedLanguage: String,
    reload: Number
  },
  data () { return {} },
  components: {},
  methods: {
    hello: function(index, content) {
      this.$emit('scroll', index, content)
    },
    open: function(collapseId) {
      this.$root.$emit('bv::toggle::collapse', collapseId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";
  .sidebar-block {
    border: 1px solid $light-grey;
    font-weight: bold;
    font-size: 0.9em;
    .col {
      height: 2em;
    }
    .border-before {
      border-top: 1px solid $light-grey;
    }
  }
</style>
